import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Reservation } from '../../services/reservationService';
import { ReservationConfigData, AllConfigsResponse } from '../../services/reservationConfigService';

interface ReservationsState {
  // Reservations list
  reservations: Reservation[];
  currentReservation: Reservation | null;
  pagination: {
    page: number;
    limit: number;
    totalCount: number;
    totalPages: number;
  };

  // Config
  configs: AllConfigsResponse | null;

  // UI state
  isLoading: boolean;
  isConfigLoading: boolean;
  error: string | null;
}

const initialState: ReservationsState = {
  reservations: [],
  currentReservation: null,
  pagination: {
    page: 1,
    limit: 20,
    totalCount: 0,
    totalPages: 0,
  },
  configs: null,
  isLoading: false,
  isConfigLoading: false,
  error: null,
};

const reservationSlice = createSlice({
  name: 'reservations',
  initialState,
  reducers: {
    setReservations: (state, action: PayloadAction<Reservation[]>) => {
      state.reservations = action.payload;
    },
    setCurrentReservation: (state, action: PayloadAction<Reservation | null>) => {
      state.currentReservation = action.payload;
    },
    setPagination: (state, action: PayloadAction<ReservationsState['pagination']>) => {
      state.pagination = action.payload;
    },
    setConfigs: (state, action: PayloadAction<AllConfigsResponse | null>) => {
      state.configs = action.payload;
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setConfigLoading: (state, action: PayloadAction<boolean>) => {
      state.isConfigLoading = action.payload;
    },
    setError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
    },
    updateReservationInList: (state, action: PayloadAction<Reservation>) => {
      const index = state.reservations.findIndex(r => r._id === action.payload._id);
      if (index !== -1) {
        state.reservations[index] = action.payload;
      }
      if (state.currentReservation?._id === action.payload._id) {
        state.currentReservation = action.payload;
      }
    },
    resetState: () => initialState,
  },
});

export const {
  setReservations,
  setCurrentReservation,
  setPagination,
  setConfigs,
  setLoading,
  setConfigLoading,
  setError,
  updateReservationInList,
  resetState,
} = reservationSlice.actions;

export default reservationSlice.reducer;
